module.exports = __webpack_public_path__ + "img/icon-audio.544a2421.svg";